import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./style.css";

interface Props {
  className?: string;
  text?: string;
}

const Quill: React.FC<Props> = ({ className, text }) => {
  return (
    <>
      <ReactQuill
        value={text}
        readOnly={true}
        modules={{ toolbar: false }}
        className={`react-quill ${className}`}
      />
    </>
  );
};

export default Quill;
